// Module
var code = "<!--ko if: Visible--> <div class=\"back-button\"> <button type=\"button\" class=\"text-sm sps-btn sps-btn-outline btn-color-configurator-back\" data-bind=\"click: Click\"> <i class=\"fa fa-angle-left\"></i> <!--ko text: _labels.BACK --><!--/ko--> </button> </div> <!--/ko-->";
// Exports
export default code;